/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React, { FC } from "react";
import { ToggleSwitch } from "components/switch/ReactSwitch";
import { streamingActions } from "modules/streaming";
import { useDispatch } from "react-redux";

export const StreamingStandbyToggleDarkmode: FC<{
  isDarkModeEnabled: boolean;
}> = ({ isDarkModeEnabled }) => {
  const dispatch = useDispatch();

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: right;
      `}
    >
      <p
        css={css`
          margin-right: 10px;
          color: ${isDarkModeEnabled ? "#fff" : "#000"};
          font-size: 12px;
        `}
        // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
      >
        ダークモード
      </p>

      {ToggleSwitch(isDarkModeEnabled, () =>
        dispatch(streamingActions.toggleDarkMode())
      )}
    </div>
  );
};
